import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  SimpleChanges,
  forwardRef,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MonthsEnum } from '@qaroni-core/types/date/months.enum';
import { MonthDayInput } from './types/month-day-input';

@Component({
  selector: 'qaroni-month-day-input',
  templateUrl: './month-day-input.component.html',
  styleUrls: ['./month-day-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthDayInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class MonthDayInputComponent implements ControlValueAccessor, OnChanges {
  readonly month = input<MonthsEnum | null>(null);
  readonly label = input($localize`Día`);

  public value: number | null = null;
  public disabled = false;

  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  get maxDay(): number {
    return MonthDayInput.getMaxDayForMonth(this.month());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['month'] || changes['month'].firstChange) {
      return;
    }

    if (this.value !== null && this.value > this.maxDay) {
      this.value = null;
      this.onChange(null);
    }
  }

  writeValue(value: number | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const raw = (event.target as HTMLInputElement).value;
    const parsed = raw === '' ? null : Number(raw);

    this.value = parsed === null || Number.isNaN(parsed) ? null : parsed;
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
